var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRetailer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.76 152.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bbe6d6;}.cls-2{fill:#92cebd;}.cls-3{fill:#d7bd75;}.cls-4{fill:#c5a764;}.cls-5{fill:#e6d691;}.cls-6{fill:#808285;}.cls-7{fill:#59595a;}.cls-8{fill:#f3f4f5;}.cls-9{fill:#818181;}.cls-10{fill:#cccfd1;}.cls-11{fill:#a2b2ae;}.cls-12{fill:#383b45;}.cls-13{fill:#c34135;}.cls-14{fill:#d4544d;}.cls-15{fill:#c3e6d6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Retailers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.58,70.17V80c23.64,4,41.18,18.56,41.18,36v.08h0v32.31c0,2.13-2.43,3.87-5.42,3.87H28c-3,0-5.42-1.74-5.42-3.87V116.06h0V116c0-17.42,17.54-32,41.17-36V70.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.58,80V70.17H77.24v82.07h48.1c3,0,5.42-1.74,5.42-3.87V116.06h0V116C130.76,98.56,113.22,84,89.58,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.71,70.17V80a69.38,69.38,0,0,0-15.05,4.27l28,34.5,28-34.5A69.47,69.47,0,0,0,89.58,80V70.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.19,70.17c-.19.6-.34,1.23-.48,1.89v1.33L95.25,95.84l9.39-11.57A69.47,69.47,0,0,0,89.58,80V70.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.77,40c0,20.15-13.2,36.5-29.48,36.5S47.82,60.17,47.82,40,61,3.52,77.29,3.52,106.77,19.86,106.77,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.12,3.54l1.17,72.88c15.35-1.27,27.48-17.08,27.48-36.4C106.77,20.2,94,4.08,78.12,3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M88.9,19.44s-21,8.15-32.61,2.33c0,0-7,17.47-6.21,32.61,0,0-13.6-35.33,12.81-50.09s44.26,12,45,27.19-1.55,18.63-1.55,18.63S107.15,22.54,88.9,19.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M78.52,0V22.46a78.07,78.07,0,0,0,10.38-3c18.25,3.1,17.48,30.67,17.48,30.67s2.33-3.49,1.55-18.63C107.32,19.56,96.13.45,78.52,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M9.33,95.5H70.17a1.75,1.75,0,0,1,1.75,1.75v53.23a1.75,1.75,0,0,1-1.75,1.75H9.33a1.76,1.76,0,0,1-1.76-1.76V97.25A1.75,1.75,0,0,1,9.33,95.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.12,145.36a1.57,1.57,0,0,1-1.66,1.46H10.93a1.57,1.57,0,0,1-1.66-1.46V101a1.57,1.57,0,0,1,1.66-1.47H68.46A1.57,1.57,0,0,1,70.12,101Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M70.12,145.36a1.57,1.57,0,0,1-1.66,1.46H10.93a1.57,1.57,0,0,1-1.66-1.46V101a1.57,1.57,0,0,1,1.66-1.47H68.46A1.57,1.57,0,0,1,70.12,101Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "11.76 94.78 7.62 115.15 71.92 128.18 71.92 105.93 16.9 94.78 11.76 94.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "12.29 99.56 9.27 114.43 9.27 115.48 70.12 127.82 70.12 106.04 38.17 99.56 12.29 99.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.79,141.31a.78.78,0,0,1-.72.83h-25a.79.79,0,0,1-.72-.83V116a.79.79,0,0,1,.72-.83h25a.78.78,0,0,1,.72.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.07,115.15h-25a.79.79,0,0,0-.72.83v.32l26.46,5.37V116A.78.78,0,0,0,39.07,115.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M38.24,139.83a.69.69,0,0,1-.63.73H15.52a.69.69,0,0,1-.64-.73V117.46a.69.69,0,0,1,.64-.73H37.61a.69.69,0,0,1,.63.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M37.61,116.73H15.52a.69.69,0,0,0-.64.73v22.37a.77.77,0,0,0,.14.45L38.09,117A.6.6,0,0,0,37.61,116.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M37.61,116.73H15.46l22.78,4.62v-3.89A.69.69,0,0,0,37.61,116.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M66.22,148.48c0,.55-.25,1-.57,1H45.75c-.32,0-.57-.45-.57-1v-30.3c0-.56.25-1,.57-1h19.9c.32,0,.57.44.57,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M65.65,117.18H45.75c-.32,0-.57.44-.57,1v4.58l21,4.27v-8.85C66.22,117.62,66,117.18,65.65,117.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M64.22,149.55c0,.55-.21,1-.47,1H47.65c-.26,0-.46-.45-.46-1V119.24c0-.55.2-1,.46-1h16.1c.26,0,.47.45.47,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M64.22,126.62v-7.38c0-.55-.21-1-.47-1H47.65c-.26,0-.46.45-.46,1v3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.8,135.64a1.93,1.93,0,1,1-1.93-1.93A1.93,1.93,0,0,1,52.8,135.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M0,102.39v5.11a7.57,7.57,0,0,0,7.53,7.6,7.58,7.58,0,0,0,7.54-7.6v-5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.11,102.26v5.11a7.6,7.6,0,0,0,15.2,0v-5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M30.33,102.19v5.11a7.6,7.6,0,0,0,15.2,0v-5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.51,102.19v5.11a7.6,7.6,0,1,0,15.2,0v-5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M60.69,102.45v5.11a7.6,7.6,0,1,0,15.2,0v-5.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "15.18 102.52 20.53 84.02 8.93 84.02 0 102.52 15.18 102.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "30.36 102.52 32.14 84.02 20.53 84.02 15.18 102.52 30.36 102.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "45.53 102.52 43.75 84.02 32.14 84.02 30.36 102.52 45.53 102.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "60.71 102.52 55.35 84.02 43.75 84.02 45.53 102.52 60.71 102.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "75.89 102.52 66.96 84.02 55.35 84.02 60.71 102.52 75.89 102.52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRetailer);
export default __webpack_public_path__ + "static/media/icon-retailer.dc9c234f1d57de9cdf699b1229b21d51.svg";
export { ForwardRef as ReactComponent };